/** temporary redirect to go to non-React pages */
export const hardRedirect = (url: string): void => {
  window.location.href = url;
};
